/**
 * Identité provisoire d'Ermont Live : deux toits (la ville), un arbre (la nature), une ligne qui file
 * (la voie ferrée, la mobilité). Tracé au trait pour rester lisible à 24 px ; couleurs issues des tokens.
 */
export function LogoMark({ size = 32 }: { size?: number }) {
  return (
    <svg className="logo-mark" width={size} height={size} viewBox="0 0 40 40" aria-hidden="true" focusable="false">
      <path className="logo-mark__city" d="M5 30V21l7-6.5 7 6.5v9M15.5 17.2 23 10l7.5 7.2V30M9.5 30v-4.5h5V30" />
      <path className="logo-mark__tree" d="M33.5 30v-6.5m0 0a4.2 4.2 0 1 0 0-8.4 4.2 4.2 0 0 0 0 8.4Z" />
      <path className="logo-mark__line" d="M3 34.5c6-2.6 11.5 2.4 17.5 0S31 32 37 34.5" />
    </svg>
  );
}

export function Logo() {
  return (
    <span className="logo">
      <LogoMark />
      <span className="logo__name">Ermont Live</span>
    </span>
  );
}
